import React from 'react'
import MainBanner from '../../components/MainComponents/MainBanner'
import { bannerSpecImage, bannerTestinomialImage, mainTitle } from '../../config'
import TestinomialsSection from '../../components/TestinomialsComponents/TestinomialsSection'
import Footer from '../../components/MainComponents/Footer'

const Testimonials = () => {
  return (
    <div>
        <MainBanner
          
          bannerTitle={mainTitle}
          banenrHeadline={"Our Healing Stories"}
          showButton={false}
          bannerDescription={
            "Discover the experiences of those who have found relief and recovery through our care"
          }
        />
        <TestinomialsSection/>
        <Footer/> 
    </div>
  )
}

export default Testimonials